<script setup lang="ts">
import { computed } from 'vue';

import PresenterValueFallback from '@satellite/components/elements/presenters/PresenterValueFallback.vue';

import type {
  YardAreaDisplayField,
  YardAreaDisplayV2Data
} from '@satellite/composables/useYardAreaDisplayV2';

const { data, displayFields = ['name'] } = defineProps<{
  data: YardAreaDisplayV2Data;
  displayFields?: YardAreaDisplayField[];
}>();

const showName = computed(() => displayFields.includes('name'));
</script>

<template>
  <span
    class="d-flex yard-area-display-v2"
    v-bind="$attrs"
    :class="{
      'typography-body-sm': data.size === 'small',
      'typography-body-md': data.size === 'regular',
      'typography-heading-lg-bold': data.size === 'large'
    }">
    <template v-if="showName">
      <slot name="area-name" :area-name="data.name" :area-name-attrs="data.nameAttrs">
        <presenter-value-fallback v-if="!data.name" data-testid="yard-area-presenter-area-name" />
        <span v-else v-bind="data.nameAttrs">
          {{ data.name }}
        </span>
      </slot>
    </template>
  </span>
</template>
